export default "__VITE_ASSET__75684249__"